import { Box, Stack } from '@chakra-ui/react';
import { useState } from 'react';
import { DataTable } from './table';

export interface TestPageProps {}

enum Rank {
  Junior = 1,
  Corporal = 2,
  Sergeant = 3,
  Manager = 4,
  Colonel = 5,
  CEO = 6,
}

export const TestPage = (props: TestPageProps) => {
  const [data, setData] = useState([
    {
      id: 0,
      name: 'Bobby Brian',
      age: 21,
      rank: Rank.Junior,
      asignee: undefined,
    },
    {
      id: 1,
      name: 'James Smith',
      age: 32,
      rank: Rank.Sergeant,
      asignee: undefined,
    },
    {
      id: 2,
      name: 'Markings Boom',
      age: 27,
      rank: Rank.Corporal,
      asignee: undefined,
    },
    {
      id: 3,
      name: 'William Tackle',
      age: 41,
      rank: Rank.Manager,
      asignee: undefined,
    },
    {
      id: 4,
      name: 'Mike Williams',
      age: 42,
      rank: Rank.Colonel,
      asignee: undefined,
    },
    {
      id: 5,
      name: 'Tad Locke',
      age: 37,
      rank: Rank.Sergeant,
      asignee: undefined,
    },
  ]);


  return (
    <Box px={{ base: 1, md: 24 }} py={{ base: 1, md: 24 }}>
      <Stack spacing={6}>
        {/* <AutoCompleteField items={data} idKey="id" textKey="name" value={acValue} onChange={v => setAcValue(v.target.value)} /> */}
        <DataTable
          value={data}
          columnFactory={(dcf) => [
            dcf('id', {
              header: <>Id</>,
              render: (c) => c,
            }),
          ]}
          // columns={[
          //   {
          //     key: 'id',
          //     header: <>Id</>,
          //     render: (c, r) => c
          //   }, {
          //     key: 'name',
          //     header: <>Name</>,
          //     render: (c, r) => c,
          //     renderEdit: props => <Input value={props.value} onChange={props.onChange} onBlur={props.onClose} ref={props.ref} />,
          //   }, {
          //     key: 'age',
          //     header: <>Age</>,
          //     render: (c, r) => c,
          //     renderEdit: props => <Input ref={props.ref} value={props.value} onChange={props.onChange} onBlur={props.onClose} />
          //   }, {
          //     key: 'rank',
          //     header: <>Rank</>,
          //     render: (c, r) => c
          //   }, {
          //     key: 'asignee',
          //     header: <>Asignee</>,
          //     sortValue: v => data.find(x => x.id === v)?.name,
          //     render: (c, r) => data.find(x => x.id === c)?.name,
          //     renderEdit: props => <ControlledAutoComplete
          //       items={data}
          //       idKey="id"
          //       textKey="name"
          //       value={props.value as any}
          //       onChange={v => props.onValueChange(v, true)}
          //       isOpen={true}
          //     />
          //   }
          // ]}
          onChange={(v, c) => setData(v)}
        />
      </Stack>
    </Box>
  );
};
